import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchPlatformActivity,
  fetchPlatformBreakdown,
  fetchPlatformGrowth,
} from '@/api/platformMetrics/platformMetricsApi';
import type {
  PlatformActivity,
  PlatformBreakdown,
  PlatformGrowth,
} from '@/api/platformMetrics/platformMetricsApi.types';
import {
  PLATFORM_METRICS_ACTIVITY_QUERY_KEY,
  PLATFORM_METRICS_BREAKDOWN_QUERY_KEY,
  PLATFORM_METRICS_GROWTH_QUERY_KEY,
} from '@/constants/queryKeys';

export function usePlatformGrowthQuery(isEnabled: boolean): UseQueryResult<PlatformGrowth, Error> {
  return useQuery({
    queryKey: PLATFORM_METRICS_GROWTH_QUERY_KEY,
    queryFn: fetchPlatformGrowth,
    enabled: isEnabled,
  });
}

export function usePlatformActivityQuery(
  isEnabled: boolean
): UseQueryResult<PlatformActivity, Error> {
  return useQuery({
    queryKey: PLATFORM_METRICS_ACTIVITY_QUERY_KEY,
    queryFn: fetchPlatformActivity,
    enabled: isEnabled,
  });
}

export function usePlatformBreakdownQuery(
  isEnabled: boolean
): UseQueryResult<PlatformBreakdown, Error> {
  return useQuery({
    queryKey: PLATFORM_METRICS_BREAKDOWN_QUERY_KEY,
    queryFn: fetchPlatformBreakdown,
    enabled: isEnabled,
  });
}
